module.exports = __webpack_public_path__ + "img/23-min.5984a66a.jpg";